// Libs
import { useEffect, useState } from 'react';
import { Navigate, Outlet, useLocation, useNavigate } from 'react-router-dom';
// Components, Layouts, Pages
// Others
import { authRouteAbsolute } from '~/utils/routes/auth';
import { StorageEnum } from '~/utils/enum/base';
import { RoleEnum } from '~/utils/enum/common';
// Styles, images, icons

type Props = {
  role: RoleEnum;
};

const ProtectedRoute = (props: Props) => {
  //#region Destructuring Props
  const { role } = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  const location = useLocation();
  const navigate = useNavigate();
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  const [isLoggedIn] = useState<string | null>(localStorage.getItem(StorageEnum.ACCESS_TOKEN)! || null);
  const [currentRole] = useState<string | null>(localStorage.getItem(StorageEnum.ROLE));
  //#endregion Declare State

  //#region Implement Hook
  useEffect(() => {
    const currentRole = localStorage.getItem(StorageEnum.ROLE);
    if (currentRole === role) {
      return;
    }

    localStorage.clear();
    navigate(`${authRouteAbsolute.login}`);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);
  //#endregion Implement Hook

  //#region Handle Function
  //#endregion Handle Function

  return isLoggedIn && currentRole === role ? <Outlet /> : <Navigate to={authRouteAbsolute.login} />;
};

export default ProtectedRoute;
